// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calc{max-width:465px}.calc,.labelinput{display:block;float:left}.labelinput{width:100%}.calc label{width:370px;display:block;float:left;margin-bottom:10px}.calc input.small{width:40px;float:left;text-align:right}.calc input{border:1px solid silver}.in{background-color:#cfc}.out{background-color:#ffc;font-weight:700}.calc span.tag{float:left}.calc span.inline{background-color:#ffc;padding-left:8px;padding-right:8px}img.illustration{margin-top:15px;margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
